import Rest from '@/services/Rest';

export default class TopbarService extends Rest {
  static resource = '/topbar';
  
  static build() {
    return super.build(this.resource);
  }
}
